import React from "react";
import Chip from "@mui/material/Chip";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import {
  DeleteButton,
  EditButton,
  List,
  ShowButton,
  useDataGrid,
} from "@refinedev/mui";

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

const rolloutLabel = (percentage: number) => {
  if (percentage <= 0) return "Off";
  if (percentage >= 100) return "On (everyone)";
  return `${percentage}%`;
};

export const FeatureFlagList = () => {
  const { dataGridProps } = useDataGrid({});

  const columns = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "key",
        flex: 1.2,
        headerName: "Key",
        minWidth: 220,
        display: "flex",
        renderCell: ({ row }) => <code>{row.key}</code>,
      },
      {
        field: "percentage",
        headerName: "Rollout",
        minWidth: 140,
        display: "flex",
        renderCell: ({ row }) => (
          <Chip
            size="small"
            label={rolloutLabel(row.percentage)}
            color={row.percentage <= 0 ? "default" : row.percentage >= 100 ? "success" : "warning"}
          />
        ),
      },
      {
        field: "description",
        flex: 1.4,
        headerName: "Description",
        minWidth: 220,
        display: "flex",
      },
      {
        field: "updatedAt",
        flex: 1,
        headerName: "Updated At",
        minWidth: 180,
        display: "flex",
        valueFormatter: (value) => formatDateTime(value as string | null | undefined),
      },
      {
        field: "actions",
        headerName: "Actions",
        align: "right",
        headerAlign: "right",
        minWidth: 120,
        sortable: false,
        display: "flex",
        renderCell: ({ row }) => (
          <>
            <EditButton hideText recordItemId={row.id} />
            <ShowButton hideText recordItemId={row.id} />
            <DeleteButton hideText recordItemId={row.id} />
          </>
        ),
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid {...dataGridProps} columns={columns} />
    </List>
  );
};
